// extracted by mini-css-extract-plugin
export default {"alertTitle":"index_alertTitle__dECzd","alertContent":"index_alertContent__82nHu","alertConfirmText":"index_alertConfirmText__yslnV","alertCancelText":"index_alertCancelText__e2oDZ"};